import { Typography } from "antd"
import cls from "classnames"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"

import FaqCard from "./components/FaqCard"

const { Title, Text } = Typography

const benefitsData = [
  {
    title: "Earn cash for every alert",
    text: "Get paid whenever your referrals receive a chargeback alert. Simple and rewarding."
  },
  {
    title: "Milestone bonuses",
    text: "Unlock bonus rewards for hitting alert milestones. The more alerts your friends’ businesses receive, the more you earn"
  },
  {
    title: "Ongoing earnings for life",
    text: "Enjoy continuous rewards as your referrals grow. Earn not just from their first business account but from every new one they create over time, all automatically."
  },
  {
    title: "Sticky customers",
    text: "Businesses that join Chargeback.io tend to stick around, which means your referrals continue generating earnings for you over the long term without any extra effort."
  },
  {
    title: "Lower your own alert costs",
    text: "The commissions you earn can cover your alert expenses, effectively making Chargeback.io a free service and even allowing you to earn extra cash."
  },
  {
    title: "Fast & easy referral process",
    text: "Share your link or send an email. It takes seconds to start earning."
  }
]

const Benefits = () => {
  const { t } = useTranslation()
  const faq = useSelector((state) => state.referrals?.faq)
  const { userInfo } = useSelector((state) => state.auth)
  const isOutsider = userInfo?.referral_outsider
  const isMobile = useSelector((state) => state.nav.isMobile)

  return (
    <div className="benefits-block">
      <Title level={4}>{t("Benefits of the program")}</Title>
      <Text type="secondary">
        {t("Earn passive income effortlessly by referring others to Chargeback.io.")}
      </Text>
      <div className={cls("faq-grid", { "faq-grid-outsider": isOutsider })}>
        {benefitsData.map((item) => (
          <FaqCard
            styles={{ minHeight: !isMobile && "226px" }}
            key={item.title}
            title={item.title}
            text={item.text}
          />
        ))}
      </div>
    </div>
  )
}

export default Benefits
